<template>
    <div class="keepet_home site_page">
        <div class="blur_bg">
            <div class="wrapper_page">
                <div>
                    <header style="height:80px;line-height:80px;">
                        <div class="main_cont flex-between head_cont">
                            <v-img
                                max-height="35"
                                max-width="160"
                                src="../assets/imgs/qinban_logo.svg"
                                alt="亲伴宠物 Logo"
                            ></v-img>
                            <div class="lists_title flex-end color-snow fw5 fz16">
                                <div v-for="(item,index) in tabsLists" :key="index" @click="gotoLink(item.type)">{{item.name}}</div>
                            </div>
                        </div>
                    </header>
                    <div class="cont_box flex-center">
                        <div class="video_box">
                            <div class="video_srcs">
                                <video class="my_video" muted="muted" preload="auto" autoplay loop="true" id="video">
                                    <source src="https://cdn.keepet.cn/video/version220527.mp4" type="video/mp4">
                                    <track default="" kind="captions" srclang="en" src="">
                                </video>
                            </div>
                            <div class="video_iphone"></div>
                        </div>
                        <div class="right_cont flex-around flex-col">
                            <div class="color-snow same_widt  mt30">
                                <v-img
                                    max-height="233"
                                    max-width="339"
                                    src="../assets/imgs/text_new.png"
                                    alt="亲伴宠物介绍文案"
                                ></v-img>
                                <div class="qrcode_mian same_widt mt80">
                                    <div class="qrcode_container flex-start">
                                        <div class="qrcode_item">
                                            <div class="qrcode_box flex-center">
                                                <v-img
                                                    max-height="100"
                                                    max-width="100"
                                                    src="../assets/imgs/qrcode_download.png"
                                                    alt="App 下载"
                                                    transition="slide-x-transition"
                                                ></v-img>
                                            </div>
                                            <div class="color-snow mt10 text-center">App 下载</div>
                                        </div>
                                        <div class="qrcode_item">
                                            <div class="qrcode_box flex-center">
                                                <v-img
                                                    max-height="100"
                                                    max-width="100"
                                                    src="../assets/imgs/qrcode_img.png"
                                                    alt="微信小程序码"
                                                    transition="slide-x-transition"
                                                ></v-img>
                                            </div>
                                            <div class="color-snow mt10 text-center">微信扫码体验</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            
                        </div>
                    </div>
                </div>
            </div>
            <div class="main_cont">
                <div class="flex-center pb40">
                    <v-img
                        max-height="42"
                        max-width="330"
                        src="../assets/imgs/text-jdcw.png"
                        alt="亲伴宠物文案图片"
                    ></v-img>
                </div>
                <div class="liner_bottom mb30"></div>
                <div class="fz12 company_infos pb40 flex-between">
                    <div>Copyright © 2021 - 2025 keepet.cn・<a href="https://beian.miit.gov.cn" target="_blank">沪ICP备17041590号-2</a></div>
                    <div class="flex-end pr10">
                        <v-tooltip top :color="'transparent'">
                            <template v-slot:activator="{ on, attrs }">
                                <v-img
                                    height="34"
                                    width="34"
                                    v-bind="attrs"
                                    v-on="on"
                                    class="mr20 img_cur"
                                    src="../assets/imgs/img_wechat.png"
                                    alt="微信"
                                >
                                </v-img>
                            </template>
                            <div class="hover_cont flex-center">
                                <v-img
                                    max-height="113"
                                    max-width="96"
                                    src="../assets/imgs/wx_qrcode.png"
                                    alt="微信二维码"
                                >
                                </v-img>
                            </div>
                        </v-tooltip>
                        <v-img
                            height="34"
                            width="34"
                            class="mr20 img_cur"
                            src="../assets/imgs/redbook.png"
                            alt="小红书"
                            @click="gotoLink('redbook')"
                        >
                        </v-img>
                        <v-img
                            height="34"
                            width="34"
                            class="mr20 img_cur"
                            src="../assets/imgs/img_zhihu.png"
                            alt="知乎"
                            @click="gotoLink('zhihu')"
                        >
                        </v-img>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Home',
    props: {
      
    },
    data() {
        return{

            tabsLists:[
                {name:'首页',type:''},
                // {name:'养宠知识库',type:'knowledge'},
                {name:'关于我们',type:'about'},
                {name:'APP下载',type:'download'},
                // {name:'使用帮助',type:''}
            ]
        }
    },
    methods: {

        gotoLink(type) {
            let link = type == 'redbook' ? 'https://www.xiaohongshu.com/user/profile/557a39c962a60c0c3fc46c16':
                type == 'zhihu' ? 'https://www.zhihu.com/org/keepetchong-wu-ji':
                type == 'knowledge' ? 'https://shenlian.feishu.cn/wiki/T6JAwPDvciccc0kgPLPcTto9nQz' :
                type == 'about' ? 'https://mp.weixin.qq.com/s/VohLLw2XABd0WVbPX50WQw' :
                type == 'download' ? '/app.html' :''
            
            if (link !='') { 
                if (type == 'download') {
                    // APP下载链接在当前窗口打开
                    window.location.href = link;
                } else {
                    // 其他链接在新窗口打开
                    window.open(link,'_blank');
                }
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .site_page {
        width: 100%;
        position: relative;
        background: rgba(0,11,28,0.25) url('../assets/imgs/bg.png') top no-repeat;
        background-size: cover;
        background-color: rgba(0,11,28,0.25);
    }
    .blur_bg {
        background-color: rgba(0,11,28,0.25);
    }
    .site_page .wrapper_page{
        height: 100vh;
        width: 100%;
    }
    header {
        padding: 0 30px;
        width: 100%;
        min-width: 800px;
        left: 0;
        top: 0;
        overflow: hidden;
        margin: 0 auto;
        z-index: 2;
        -webkit-transition: height 400ms;
        transition: height 400ms;
        background: none;
    }
    .main_cont {
        max-width: 1200px;
        margin: 0 auto;
        &.head_cont{
            height: 80px;
        }
    }
    .lists_title {
        position: relative;
        >div{
            line-height: 40px;
            margin-right: 50px;
            cursor: pointer;
            &:nth-child(4n) {
                margin-right: 0;
            }
        }

    }
    .cont_box {
        height: calc(100vh - 160px);
        overflow: hidden;
        margin: 0 auto;
        .video_box {
            position: relative;
                width: 260px;
                height: 564px;
            .video_srcs {
                position: absolute;
                width: 260px;
                height: 564px;
                margin: 13px 20px;
                .my_video {
                    width: 260px;
                    height: 565px;
                }
            }
            .video_iphone {
                position: absolute;
                width: 300px;
                height: 590px;
                background: url('../assets/imgs/phone_bg1.png') no-repeat center;
                background-size: contain;
            }
        }
    }
    .right_cont {
        flex-shrink: 0;
        width: 600px;
        height: calc(100vh - 300px);
        margin-left: 100px;
        .same_widt {
            width: 600px;
        }
        .qrcode_container {
            width: 100%;
            gap: 40px;
        }
        .qrcode_item {
            display: flex;
            flex-direction: column;
            align-items: center;
        }
        .qrcode_box {
            width: 120px;
            height: 120px;
            background-color: #fff;
            border-radius: 20px;
        }
    }
    .liner_bottom {
        height: 1px;
        background-color: rgba(255,255,255,0.4);
    }
    .company_infos,
    .company_infos a {
        color: rgba(255,255,255,0.8);
        text-decoration-line: none;
    }
    .hover_cont {
        width: 130px;
        height: 139px;
        background:url('../assets/imgs/rectangle_bg.png') no-repeat center;
        background-size: cover;
    }
    .img_cur {
        cursor: pointer;
    }
</style>
